import { render, staticRenderFns } from "./FinishedProducts.vue?vue&type=template&id=bc803e50&scoped=true&"
import script from "./FinishedProducts.vue?vue&type=script&lang=js&"
export * from "./FinishedProducts.vue?vue&type=script&lang=js&"
import style0 from "./FinishedProducts.vue?vue&type=style&index=0&id=bc803e50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc803e50",
  null
  
)

export default component.exports